import { UAPPlacementTypeAlias as PT } from '@bingads-webui-campaign-react/unified-ad-preview-library-cmui';

// LinkedIn only supports one image
export const PREVIEW_IMAGE_INDEX = 0;

export const LinkedInImageType = {
  Landscape: 'Image191x100',
  Square: 'Image1x1',
  Vertical: 'Image4x5',
};

export const LinkedInImageTypeAspectRatio = {
  [LinkedInImageType.Landscape]: 1.91,
  [LinkedInImageType.Square]: 1,
  [LinkedInImageType.Vertical]: 0.8,
};

export const LinkedInImageTypeMinSize = {
  [LinkedInImageType.Landscape]: [690, 360],
  [LinkedInImageType.Square]: [360, 360],
  [LinkedInImageType.Vertical]: [512, 640],
};

export const AdPreviewConfig = [
  {
    placementSetName: LinkedInImageType.Landscape,
    placementTypes: [
      PT.LinkedIn.Landscape.SingleImageDesktop,
      PT.LinkedIn.Landscape.SingleImageMobile,
    ],
  },
  {
    placementSetName: LinkedInImageType.Square,
    placementTypes: [
      PT.LinkedIn.Square.SingleImageDesktop,
      PT.LinkedIn.Square.SingleImageMobile,
    ],
  },
  {
    placementSetName: LinkedInImageType.Vertical,
    placementTypes: [
      PT.LinkedIn.Vertical.SingleImageMobile,
    ],
  }];

export const AdPreviewExtraPlacementInfo = {
  [PT.LinkedIn.Landscape.SingleImageDesktop]: {
    previewTitle: _TL_('Desktop feed'),
  },
  [PT.LinkedIn.Landscape.SingleImageMobile]: {
    previewTitle: _TL_('Mobile feed'),
  },

  [PT.LinkedIn.Square.SingleImageDesktop]: {
    previewTitle: _TL_('Desktop feed'),
  },
  [PT.LinkedIn.Square.SingleImageMobile]: {
    previewTitle: _TL_('Mobile feed'),
  },

  [PT.LinkedIn.Vertical.SingleImageMobile]: {
    previewTitle: _TL_('Mobile feed'),
  },
};
